import React, {useState} from 'react';
import {Box, IconButton, Typography} from '@mui/material';
import {User} from "../types";
import SearchForm from "./SearchForm";
import LogoutIcon from "@mui/icons-material/Logout";
import {useAuth} from "../providers/AuthProvider";
import {AdminUserInfoCard} from "./AdminUserInfoCard";
import {useToast} from "use-toast-mui";

export const AdminPortalScreen = () => {
    const [user, setUser] = useState<User | null | undefined>(undefined)
    const {logOut} = useAuth()
    const toast = useToast()

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            mx: 'auto'
        }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'flex-end',
            }}>
                <Typography variant="h4" sx={{mt: 4}}>Admin Portal</Typography>
                <IconButton aria-label="log-out" onClick={async () => {
                    try {
                        await logOut();
                    } catch (error) {
                        toast.error('Error signing out.');
                    }
                }}>
                    <LogoutIcon fontSize="inherit"/>
                </IconButton>
            </Box>
            <SearchForm setUser={setUser}/>
            {
                !user &&
                <Typography variant="body1" sx={{mt: 4}}>
                    {
                        user === null ?
                            'No user found with this email/key. Please verify you copied the right credentials.' :
                            'Enter a user\'s email/key to perform any action on their account.'
                    }
                </Typography>
            }
            {user && <AdminUserInfoCard user={user} setUser={setUser}/>}
        </Box>
    );
}
